<template>
  <div class="oem-tongue" :class="{ 'ext': isExt }">
    <div class="short" @click="onShortClick">
      <img :src="oem_help_short">
    </div>
    <div class="long">
      <div class="depth">
        <img :src="oem_help_long">
        <svg-icon icon="oem_close" size="20px" @click="onClickClose"/>
        <div class="buttons">
          <a href="https://v.youku.com/v_show/id_XNDE3MjI4ODg4MA==.html?spm=a2h3j.8428770.3416059.1" target="_blank">
            <p>CMS功能介绍</p>
            <span>10分钟了解全面功能</span>
          </a>
          <a href="https://v.youku.com/v_show/id_XNDE3MjMyMjg2MA==.html?spm=a2h3j.8428770.3416059.1" target="_blank">
            <p>CMS配置介绍</p>
            <span>轻松几步，开启你的平台</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import oem_help_long from '@/images/oem_help_long.png'
import oem_help_short from '@/images/oem_help_short.png'
import { countdownSeconds } from '@/utils/timer'
export default {
  name: '',
  data: () => ({
    oem_help_long,
    oem_help_short,
    isExt: true,
    timer: null,
    sec: 3,
  }),
  methods: {
    onShortClick() {
      // 展开舌头
      this.isExt = true
    },
    onClickClose() {
      this.isExt = false
      clearInterval(this.timer)
    }
  },
  mounted() {
    clearInterval(this.timer)
    this.timer = countdownSeconds({
      current: (count) => {
        this.sec = count
      },
      lastone: () => {
        this.ser = 3
        this.isExt = false
        clearInterval(this.timer)
      },
      count: 3,
    })
  }
}
</script>

<style lang="scss" scoped>
.oem-tongue {
  position: fixed;
  bottom: 80px;
  left: 0;
  height: 156px;
  z-index: 10;
}
.ext {
  .short {
    left: -132px;
  }
  .long {
    left: 0;
  }
}
.short {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
  transition: all .5s;
}
.long {
  position: absolute;
  left: -100vw;
  // top: 0;
  bottom: 0;
  background: linear-gradient(to bottom, #4C95FD, #326DFA);
  width: 100vw;
  height: 120px;
  transition: all .5s;

  .depth {
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    position: relative;
  }

  img {
    height: 156px;
    position: absolute;
    top: -36px;
    left: 0;
    right: 0;
  }
  .svg-icon {
    pointer-events: all;
    position: absolute;
    right: 16px;
    top: 8px;
    cursor: pointer;
    z-index: 1;
  }
}
.buttons {
  min-width: 528px;
  padding: 28px 0;
  position: relative;
  position: absolute;
  right: 72px;
  top: 0;
  a {
    display: inline-block;
    padding-top: 13px;
    border-radius: 4px;
    border: none;
    height: 64px;
    min-width: 254px;
    text-align: left;
    padding-left: 24px;
    color: $theme-textmain;
    font-weight: normal;
    background: url('~@/images/oem_help_video_blue.png') no-repeat #FFF;
    background-position: center right;
    transition: none;
    p {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
    }
    span {
      font-size: 12px;
      line-height: 17px;
    }

    +a {
      background: url('~@/images/oem_help_video_yellow.png') no-repeat #FFF;
      background-position: center right;
      margin-left: 20px;
    }
  }
}
img {
  display: block;
}
</style>